import { DataEntityBase, Models } from ".";
import { IConstructorOptions } from "../../../Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";
import { CurrentDaysFocus } from "./DailyEntry";


export enum TutorialStateProperties {
    stepIndex= '_stepIndex',
    isRunning = '_isRunning',
    previousFocus = '_previousFocus',
}

export class TutorialState extends DataEntityBase {

    
    public static get TypeName() { return Models.TutorialState  ; }

    public static CreateId(key: string) {
        return DataEntityBase.CreateId(TutorialState.TypeName, key)
    };


    public static Create(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        var retVal = new TutorialState(options);
        watcher.RegisterEntity(retVal);
        return retVal;
    }
    
    public get stepIndex(): number { return this[TutorialStateProperties.stepIndex]; }
    public set stepIndex(value: number) { this.UpdateAndFire(TutorialStateProperties.stepIndex, value); }
    [TutorialStateProperties.stepIndex] = 0;
    
    public get isRunning(): boolean { return this[TutorialStateProperties.isRunning]; }
    public set isRunning(value: boolean) { this.UpdateAndFire(TutorialStateProperties.isRunning, value); }
    [TutorialStateProperties.isRunning] = true;

    public get previousFocus(): CurrentDaysFocus { return this[TutorialStateProperties.previousFocus]; }
    public set previousFocus(value: CurrentDaysFocus) { this.UpdateAndFire(TutorialStateProperties.previousFocus, value); }
    [TutorialStateProperties.previousFocus] = CurrentDaysFocus.Morning;

    protected constructor(options?: IConstructorOptions) {

        super(
            {
                typename: TutorialState.TypeName,
                serializationProperties: TutorialStateProperties,
                dateProperties: TutorialState.completableDateProperties,
                jsonProperties: TutorialState.completableJsonProperties
            });
            this.CompleteConstruction(options);
    }


    private static completableDateProperties: string[] = [
    ];


    private static completableJsonProperties: string[] = [
    ];

}